module.exports = __webpack_public_path__ + "static/media/twitter.6647284d.svg";